import React from "react";
import { MobileTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

/** AdapterDayjs requires dayjs values; API-mapped store hours used to pass Date. */
function toPickerValue(value) {
  if (value == null || value === "") return null;
  if (typeof value?.isValid === "function") {
    return value.isValid() ? value : null;
  }
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

const CustomTimePicker = ({ value, onChange, handleAccept, label,height = 50, placeholder = "", ...props }) => {
  return (
   <MobileTimePicker
  value={toPickerValue(value)}
  onChange={onChange}
  onAccept={handleAccept} 
  {...props}
  slotProps={{
    textField: {
      fullWidth: true,
      label,
      placeholder,
      InputProps: {
        sx: {
          borderRadius:"10px",
          height,
          fontSize: 14
        },
        
      },
    },
  }}
/>

  );
};

export default CustomTimePicker;
